export default "__VITE_ASSET__DufHOkLL__"